// RegisterPage: register form using AuthContext
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AlertMessage from "../components/AlertMessage";
import SimpleCaptcha from "../components/SimpleCaptcha";

export default function RegisterPage() {
  const navigate = useNavigate();
  const { register, isAuthenticated } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/tours", { replace: true });
    }
  }, [isAuthenticated, navigate]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaReset, setCaptchaReset] = useState(0);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Vérifier le CAPTCHA avant de soumettre
    if (!captchaValid) {
      setError("Please solve the security check correctly");
      return;
    }

    setIsLoading(true);

    const result = await register(form);
    setIsLoading(false);

    if (result.success) {
      navigate("/tours");
    } else {
      setError(result.error || "Registration failed");
      setCaptchaValid(false);
      setCaptchaReset((prev) => prev + 1);
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <h1 className="mb-4 text-2xl font-bold">Register</h1>
      {error && (
        <div className="mb-3">
          <AlertMessage type="error">{error}</AlertMessage>
        </div>
      )}
      <form
        onSubmit={handleSubmit}
        className="space-y-3 rounded-xl border border-slate-200 p-4 dark:border-slate-800"
      >
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="Name"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />
        <input
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />
        <input
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Password"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />
        <input
          name="password_confirmation"
          type="password"
          value={form.password_confirmation}
          onChange={handleChange}
          placeholder="Confirm Password"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />

        {/* ✅ CAPTCHA Security Check */}
        <SimpleCaptcha
          onValidate={setCaptchaValid}
          resetTrigger={captchaReset}
        />

        <button
          type="submit"
          disabled={isLoading || !captchaValid}
          className="w-full rounded-md bg-emerald-600 px-4 py-2 font-medium text-white hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
        >
          {isLoading ? "Creating account..." : "Create My Account"}
        </button>
      </form>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
        Already registered?{" "}
        <Link to="/login" className="text-emerald-600 hover:underline">
          Log In
        </Link>
      </p>
    </div>
  );
}
